export default "__VITE_ASSET__6eZL50rt__"